// extracted by mini-css-extract-plugin
export var container = "styles-module__container___o4zHE";
export var imageCarousel = "styles-module__imageCarousel___KZDbe";
export var image = "styles-module__image___F2iKZ";
export var imagePositionUnset = "styles-module__imagePositionUnset___nFhIg";
export var content = "styles-module__content___yUV_R";
export var badge = "styles-module__badge___SMAGe";
export var focused = "styles-module__focused___SH4wI";
export var containerDescriptive = "styles-module__containerDescriptive___j1xOQ";
export var topLeftButton = "styles-module__topLeftButton___fif16";
export var topRightButton = "styles-module__topRightButton___i0BTj";